import { AppLocale } from 'modules/i18n';

export const mapFlagCode: Record<AppLocale, 'GB' | 'DE'> = {
  [AppLocale.en_US]: 'GB',
  [AppLocale.de_DE]: 'DE'
};
